import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { Navigate, useNavigate } from "react-router-dom";

import { fontSize, Stack } from "@mui/system";
import { KeyboardArrowDown } from "@mui/icons-material";

import store from "../../mobx";
import MixQuickBrandText from "../../components/BrandText/MixQuickBrandText";
import zIndex from "@mui/material/styles/zIndex";
import { useState } from "react";

export const MixQuickProductCard = observer(function MixQuickProductCard() {
  const [hovering, setHovering] = useState(false);
  const { isPhone } = store.mediaBreakpointStore;

  const navigate = useNavigate();

  return (
    <Stack
      alignItems="center"
      sx={{
        position: "relative",
      }}
    >
      <Box sx={{ px: 2 }}>
        <CardActionArea
          sx={{ minWidth: "75vw", borderRadius: 4 }}
          onMouseEnter={() => setHovering(!hovering)}
          onMouseLeave={() => setHovering(!hovering)}
          onClick={() => navigate("/mixquick")}
        >
          <Card
            sx={(theme) => ({
              //
              borderRadius: 4,

              border: `1px solid ${theme.palette.primary.light}`,
            })}
          >
            <CardMedia
              component="img"
              src="/screenshots/clipper.jpg"
              height={isPhone ? 400 : 600}
              sx={{
                objectFit: "cover",

                objectPosition: "center 25%",
                // borderRadius: 4, // Rounded corners on the image itself

                transition: "transform 0.5s ease",
                // animation: "scrollImage 12s ease-in-out infinite alternate",

                "@keyframes scrollImage": {
                  "0%": {
                    objectPosition: "top",
                  },
                  "100%": {
                    objectPosition: "bottom",
                  },
                },

                transform: hovering
                  ? "scale(1.05) translate(5px, -5px)"
                  : "translate(0px, -15px)",
              }}
            />
            <Stack>
              <Button
                color="altPrimary"
                variant="contained"
                sx={{
                  marginLeft: "auto",
                  marginRight: 2,
                  marginBottom: 2,
                  color: "black",
                }}
              >
                view
              </Button>
            </Stack>
            {/* Gradient overlay */}
            <Box
              sx={{
                position: "absolute",
                borderRadius: 4,
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                background: isPhone
                  ? "linear-gradient(to right, rgba(0,0,0,0.99), rgba(255,255,255,0))"
                  : "linear-gradient(to right, rgba(0,0,0,0.98), rgba(255,255,255,0))",
              }}
            />
            <CardText
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                mt: 4,
                ml: 2,
                zIndex: 1,
                transform: "translateZ(0)", // <-- force GPU layer
                willChange: "opacity", // hint to browser not to blend with background
              }}
            />
          </Card>
        </CardActionArea>
      </Box>
    </Stack>
  );
});

function CardText({ sx }) {
  return (
    <Box sx={sx}>
      <MixQuickBrandText sx={{ fontSize: 48 }} />
      <Box
        sx={{
          height: "4px", // thickness of the underline
          width: "33%",
          borderRadius: 2,
          background: "linear-gradient(to right, orange, transparent)", // gradient colors
          mt: 2,
          mb: 2,
        }}
      />
      <Box mb={2} />
      <Typography paragraph>
        Speed up your mixing workflow by <b>4x</b> with superior results, novice
        or pro
      </Typography>
      <List
        sx={{
          pointerEvents: "none",
          listStyleType: "disc",
          pl: 2,

          "& .MuiListItem-root": {
            display: "list-item",
          },
        }}
      >
        {[
          "Clipper",
          "Saturator (Multiband)",
          "Stereo Widener (Multiband)",
          "Auto Gain",
          "Meters",
        ].map((text, index) => (
          <ListItem
            key={index}
            component="li" // <-- semantic <li>
            sx={{
              py: 0.5,
            }}
          >
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}
